export const parseNoteToFormat = (note) => {
  if (!note) return { note: '', taggedUsers: [] };

  const noteStr = note?.replaceAll('<br>', '\n');
  const dom = new DOMParser()?.parseFromString(
    noteStr,
    'text/html'
  )?.documentElement;
  const mentionSpans = dom?.querySelectorAll('span.mention');
  const taggedUsers = [];
  for (let i = 0; i < mentionSpans.length; i++) {
    const mention = mentionSpans[i];
    const userUuidAndId = mention.getAttribute('data-id');
    const [userUuid, userId] = userUuidAndId?.split(':');
    taggedUsers?.push(+userId);
    mention.innerText = `@${userUuid}`;
  }
  const paragraphs = dom?.getElementsByTagName('p');
  const paragraphTexts = [];
  for (let i = 0; i < paragraphs.length; i++) {
    const paragraph = paragraphs[i];
    paragraphTexts.push(paragraph?.textContent || '');
  }
  return {
    note: paragraphTexts.join(''),
    // to get only unique user ids
    taggedUsers: taggedUsers.filter(
      (value, index, array) => array.indexOf(value) === index
    ),
  };
};

const escapeHtml = (str) =>
  str
    ?.replace(/&/g, '&amp;')
    ?.replace(/</g, '&lt;')
    ?.replace(/>/g, '&gt;')
    ?.replace(/"/g, '&quot;')
    ?.replace(/'/g, '&#039;');

export const parseNoteToHtml = (message, taggedUsers) => {
  if (!message) return '';
  const userLookup = {};
  taggedUsers?.forEach((user) => {
    userLookup[user.uuid] = user;
  });

  // First escape everything to prevent XSS
  const safeMessage = escapeHtml(message);

  const htmlContent = safeMessage.replace(
    /@([a-f0-9-]{36})/g,
    (match, uuid) => {
      const user = userLookup[uuid];
      if (user) {
        return `<span class="mention" data-type="mention" data-id="${user?.uuid}:${user?.id}" data-label="${user?.name}">@${user?.name}</span>`;
      }
      return match;
    }
  );
  const htmlWithBreaks = htmlContent
    .replaceAll('\\n', '\n')
    .replace(/\n/g, '<br>');
  return `<p>${htmlWithBreaks}</p>`;
};
